import { render, staticRenderFns } from "./FlexWrapperCol.vue?vue&type=template&id=161f8bb4"
import script from "./FlexWrapperCol.vue?vue&type=script&lang=js"
export * from "./FlexWrapperCol.vue?vue&type=script&lang=js"
import style0 from "./FlexWrapperCol.vue?vue&type=style&index=0&id=161f8bb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports